export default __webpack_public_path__ + "static/media/7.b871ce47.png";